import React from "react";
import { NumberPillProps } from "./NumberPill.types";
import { NumberPillContainer, NumberPillText } from "./NumberPill.styles";

export const NumberPill: React.FC<NumberPillProps> = ({
  value,
  backgroundColor,
  textColor,
  showBorder = false,
  borderColor,
  borderWidth = "1px",
  minHeight = "16px",
  px,
  py = "2px",
  borderRadius,
  fontSize = "10px",
  fontWeight = 700,
  lineHeight = "1",
  letterSpacing = "0",
  onClick,
  className,
  dataCy,
  position,
  top,
  right,
  bottom,
  left,
  zIndex,
}) => {
  const stringValue = String(value);
  const isSingleDigit = stringValue.length === 1;

  // Calculate border radius: circular for single digit, rounded rectangle for multi-digit
  const calculatedBorderRadius =
    borderRadius || (isSingleDigit ? "50%" : `${parseInt(minHeight) / 2}px`);

  // Calculate padding: more padding for multi-digit numbers
  const calculatedPx = px || (isSingleDigit ? "4px" : "6px");

  // Calculate width: ensure minimum width equals height for single digit (perfect circle)
  const minWidth = isSingleDigit ? minHeight : "auto";

  return (
    <NumberPillContainer
      value={value}
      backgroundColor={backgroundColor}
      textColor={textColor}
      showBorder={showBorder}
      borderColor={borderColor}
      borderWidth={borderWidth}
      minHeight={minHeight}
      minWidth={minWidth}
      px={calculatedPx}
      py={py}
      borderRadius={calculatedBorderRadius}
      fontSize={fontSize}
      fontWeight={fontWeight}
      onClick={onClick}
      className={className}
      data-cy={dataCy}
      position={position}
      top={top}
      right={right}
      bottom={bottom}
      left={left}
      zIndex={zIndex}
    >
      <NumberPillText
        textColor={textColor}
        fontSize={fontSize}
        fontWeight={fontWeight}
        lineHeight={lineHeight}
        letterSpacing={letterSpacing}
      >
        {stringValue}
      </NumberPillText>
    </NumberPillContainer>
  );
};
